import { render } from "./SelectArea.vue?vue&type=template&id=0c886181&scoped=true"
import script from "./SelectArea.vue?vue&type=script&lang=js"
export * from "./SelectArea.vue?vue&type=script&lang=js"

import "./SelectArea.vue?vue&type=style&index=0&id=0c886181&scoped=true&lang=scss"

import exportComponent from "D:\\project\\php\\quick_wucode\\quick_wucode\\quickadmin\\vue3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c886181"]])

export default __exports__